export const SET_ACTIVE_MODAL = 'SET_ACTIVE_MODAL';
export const RESET_ACTIVE_MODAL = 'RESET_ACTIVE_MODAL';

export const setActiveModal = (activeModal, modalProps) => {
  return dispatch => {
    dispatch({ type: SET_ACTIVE_MODAL, payload: { activeModal, modalProps } });
  };
};

export const resetActiveModal = () => {
  return dispatch => {
    dispatch({ type: RESET_ACTIVE_MODAL });
  };
};

export const initialModalState = {
  activeModal: null,
  modalProps: {}
};

export default function modals(state = initialModalState, action) {
  switch (action.type) {
    case SET_ACTIVE_MODAL:
      return { ...state, activeModal: action.payload.activeModal, modalProps: action.payload.modalProps };
    case RESET_ACTIVE_MODAL:
      return initialModalState;
    default:
      return state;
  }
}
